import { styles } from "Dashboard/components/SelectStyle";

const customMultiSelectStyle = {
  ...styles.dropdownInTable,

  option: (provided: any, { isSelected }: { isSelected: boolean }) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontSize: 12,
    backgroundColor: isSelected ? '#1967d2' : provided.backgroundColor,
    color: isSelected ? 'white' : provided.color,
    ':hover': {
      backgroundColor: isSelected ? '#8b0000' : provided.backgroundColor,
      scale: isSelected ?? '1.2'
    }
  }),

  multiValue: (provided: any) => ({
    ...provided,
    display: "flex",
    justifyContent: "space-between",
    width: "82%",
    borderRadius: '10px',
    margin: "0 2px"
  }),

  multiValueLabel: (provided: any) => ({
    ...provided,
    color: '#333',
    padding: '2px 6px'
  }),

  multiValueRemove: (provided: any) => ({
    ...provided,
    color: '#696969',
    fontSize: '18px',
    borderRadius: "10px",
    ':hover': {
      backgroundColor: "#FFCCCB",
      scale: "1.1"
    }
  }),
}

export const stylesMulti = {
  customMultiSelectStyle
}
